import styled from 'styled-components'
import { breakpoints, colors } from '@/styles'
import { H4 } from '@/components/text'

const AreaTitle = styled(H4)<{ top?: number; bottom?: number; textAlign?: string }>`
  color: ${colors.black};
  text-align: ${props => props.textAlign};
  margin-bottom: ${props => props.bottom}px;
  margin-top: ${props => props.top}px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 20px;
    line-height: 28px;
  }
`
AreaTitle.defaultProps = {
  top: 48,
  bottom: 24,
  textAlign: 'center'
}

export default AreaTitle
